module.exports = __webpack_public_path__ + "79059ed3af9e27190334c813d6202c77.glb";